import { topics } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            <span>大家都在聊</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            漫迷们正在热议的漫画话题，加入讨论发现同好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href={`#ranking`}
              onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 border-background-200/70 text-foreground-700 hover:border-primary-200/60 hover:text-primary-500'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-background-50/80' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
              {topic.hot && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-accent-300"></i>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}